import PartnerDataStatistic from './index'

export default {
  path: '/home/dataReport/partnerDataStatistic',
  component: PartnerDataStatistic,
  meta: { title: '合伙人数据统计' },
}
